export function unique(arr: string[]): string[] {
  const uniqueItems = []
  const uniqueObj = {}

  arr.forEach(key => {
    if (!uniqueObj[key]) {
      uniqueObj[key] = true
      uniqueItems.push(key)
    }
  })

  return uniqueItems
}
